import "../styles/main.css";
import "@/lib/select.js";
import app from "@/app.js";

/**
 * mount any components defined on the page
 */
app.mount();
